import { Button } from "@/components/ui/button";
import { Share2, Facebook, MessageCircle, Link2, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { toast } from "sonner";

const SocialShare = ({ sagra }) => {
  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';
  const shareTitle = `${sagra.nome} - Sagre Italia`;
  const shareText = `Scopri ${sagra.nome} a ${sagra.comune}, ${sagra.provincia}! ${sagra.descrizione.slice(0, 100)}...`;

  const shareOptions = [
    {
      name: "WhatsApp",
      icon: MessageCircle,
      color: "bg-green-500 hover:bg-green-600",
      url: `https://wa.me/?text=${encodeURIComponent(`${shareTitle}\n\n${shareText}\n\n${shareUrl}`)}`
    },
    {
      name: "Facebook",
      icon: Facebook,
      color: "bg-blue-600 hover:bg-blue-700",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`
    },
    {
      name: "X (Twitter)",
      icon: X,
      color: "bg-black hover:bg-gray-800",
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`
    }
  ];

  const handleShare = (option) => {
    window.open(option.url, '_blank', 'width=600,height=400');
  };

  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    toast.success("Link copiato negli appunti!");
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl
        });
      } catch (err) {
        // User cancelled or error
      }
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button 
          variant="outline" 
          className="rounded-lg gap-1.5"
          data-testid="share-btn"
        >
          <Share2 className="w-4 h-4" />
          Condividi
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="end">
        <div className="space-y-2">
          <p className="text-sm font-medium text-foreground mb-3">Condividi su</p>
          
          {shareOptions.map((option) => (
            <button
              key={option.name}
              onClick={() => handleShare(option)}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-white transition-colors ${option.color}`}
              data-testid={`share-${option.name.toLowerCase().replace(/[^a-z]/g, '')}`}
            >
              <option.icon className="w-4 h-4" />
              <span className="text-sm font-medium">{option.name}</span>
            </button>
          ))}
          
          <div className="border-t border-border pt-2 mt-2">
            <button
              onClick={copyLink}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-lg bg-muted hover:bg-muted/80 text-foreground transition-colors"
              data-testid="share-copy-link"
            >
              <Link2 className="w-4 h-4" />
              <span className="text-sm font-medium">Copia link</span>
            </button>
          </div>
          
          {typeof navigator !== 'undefined' && navigator.share && (
            <button
              onClick={handleNativeShare}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
              data-testid="share-native"
            >
              <Share2 className="w-4 h-4" />
              <span className="text-sm font-medium">Altre opzioni</span>
            </button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default SocialShare;
